import * as React from "react";
import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Typography from "@mui/material/Typography";
import { Divider } from "@mui/material";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled';
import './eventsCard.css'

export default function ResearchCard({
    author, url, image, title, coinsUsed, icons, date
}) {
    const cardRef = React.useRef();

    function isMobile() {
        const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        const minSize = 450;
        return screenWidth <= minSize;
    }
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    function getYtThumbnail() {
        if (!url.includes("http") && url.length === 11) return url;
        url = url.trim();


        const expressions = [
            new RegExp(
                "^https://(?:www\\.|m\\.)?youtube\\.com/watch\\?v=([_\\-a-zA-Z0-9]{11}).*$"
            ),
            new RegExp(
                "^https://(?:music\\.)?youtube\\.com/watch\\?v=([_\\-a-zA-Z0-9]{11}).*$"
            ),
            new RegExp(
                "^https://(?:www\\.|m\\.)?youtube\\.com/shorts/([_\\-a-zA-Z0-9]{11}).*$"
            ),
            new RegExp(
                "^https://(?:www\\.|m\\.)?youtube(?:-nocookie)?\\.com/embed/([_\\-a-zA-Z0-9]{11}).*$"
            ),
            new RegExp("^https://youtu\\.be/([_\\-a-zA-Z0-9]{11}).*$")
        ];

        for (const exp of expressions) {
            const match = url.match(exp);
            if (match !== null && match.length >= 2) {
                let videoId = match[1];
                return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

            }
        }

        return '';
    }

    const handleCardClick = () => {
        console.log("handleCardClick");
        window.open(url);
    };

    return (
        <Card onClick={handleCardClick} className="event-card"
            sx={{
                border: "1px solid rgba(79, 79, 79, 0.70)",
                borderRadius: "10px",
                backgroundOrigin: "center",
                backgroundSize: "cover",
                minWidth: "100%",
                height: "381px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
            }}
            elevation={5}
        >
            <CardContent className="events-card-content" sx={{ height: "182px" }}>
                <div className="image-container">
                    {/* {!image && (
                        <>
                            <img className="event-card-img" src={getYtThumbnail()} alt="event" />
                            <div className="icon-overlay">
                                <img src="./assets/play.svg" alt="marketUp" />
                            </div>
                        </>

                    )} */}
                    {image && (
                        <img className="event-card-img" src={image} alt="event" />
                    )}
                </div>
            </CardContent>

            <Box sx={{ height: "60px", margin: "14px" }}>

                <Typography className="event-content">
                    {title}
                </Typography>
            </Box>


            <Box

                sx={{
                    display: "flex",
                    padding: "0px 14px",
                    justifyContent: "space-between",
                    gap: "10px",
                    alignItems: "center",
                    height: "20px",
                    flexDirection: "row",
                }}
            >
                <Box sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "5px",
                    alignItems: "center",
                    flexDirection: "row",
                }}>

                    <CalendarMonthIcon
                        style={{
                            color: "#AEACAF",
                            fontSize: "16px",
                        }}
                    />
                    <Typography sx={{ fontSize: isMobile() ? "14px" : "16px", color: "#928F95" }}>
                        {date ? new Date(date).toLocaleDateString('en-GB', options) : new Date().toLocaleDateString('en-GB', options)}

                    </Typography>
                </Box>

                <Box
                    sx={{ display: "flex", gap: isMobile() ? "3px" : "5px", width: "max-content", marginLeft: isMobile() ? "-5px" : "0px" }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: isMobile() ? "3px" : "5px" }}>
                        <img
                            style={{ width: "15px", height: "15px", }}
                            src={icons?.[coinsUsed.toUpperCase()]}
                            alt={coinsUsed.toLowerCase()}
                        />
                        {/* <Icon name={coinsUsed.toLowerCase()} url={icons?.[coinsUsed.toUpperCase()]} /> */}
                        <Typography sx={{ fontSize: isMobile() ? "14px" : "16px", color: "#928F95" }}>{coinsUsed}</Typography>
                    </Box>
                </Box>


            </Box>


            <button class="read-more-button">Read More</button>

            {/* <Box

                sx={{
                    display: "flex",
                    padding: "14px 14px",
                    justifyContent: "space-between",
                    gap: "10px",
                    alignItems: "center",
                    flexDirection: "row",
                    height: "20px",
                }}
            >

          

            </Box> */}

        </Card>
    );
}
